import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from '../../../Link';

interface BrandProps {
  sidebarExpanded: boolean;
}

const Brand: React.FC<BrandProps> = ({ sidebarExpanded }) => {
  const { t } = useTranslation();

  return (
    <div className="app-brand demo">
      <Link
        className="app-brand-link"
        icon={
          <img
            src={
              sidebarExpanded
                ? require('../../../../assets/img/logos/Primary + Name without subtitle.png.png')
                : '/favicon.png'
            }
            className="app-brand-logo demo"
            alt={t('layout.pageTexts.private.sidebar.logoAltText')}
            style={{ height: 'auto', width: sidebarExpanded ? '150px' : '32px' }}
          />
        }
      />
    </div>
  );
};

export default Brand;
